"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginEntity = void 0;
const AppDto_1 = require("../apps/AppDto");
const AppEntity_1 = require("../apps/AppEntity");
const AuthenticationRequiredError_1 = require("../GS/AuthenticationRequiredError");
const BadRequestError_1 = require("../GS/BadRequestError");
const validators_1 = require("../GS/validators");
const LoginDto_1 = require("./LoginDto");
const Operator_1 = require("../GS/Operator");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
const LoginRole_1 = require("./LoginRole");
class LoginEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, login) {
        super();
        this._requiredFieldsSetStatus = {
            username: false,
            passwordHash: false,
            role: false
        };
        this._dependencies = dependencies;
        if (login === undefined) {
            this._dto = new LoginDto_1.LoginDto();
        }
        else if (login instanceof LoginDto_1.LoginDto) {
            this._dto = new LoginDto_1.LoginDto(login);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (login instanceof LoginEntity) {
            this._dto = new LoginDto_1.LoginDto(login._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new LoginDto_1.LoginDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getApp() {
        if (this._dto.appId === undefined) {
            return undefined;
        }
        if (this._dto.app === undefined) {
            throw new Error("Cannot call getApp without first loading the App.");
        }
        if (!this._appEntity && this._dto.app) {
            this._appEntity = new AppEntity_1.AppEntity(this._dependencies, this._dto.app);
        }
        return this._appEntity;
    }
    setApp(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof AppEntity_1.AppEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof AppDto_1.AppDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setAppId(untrustedId);
        if (this.hasError("appId")) {
            return;
        }
        if (untrustedValue instanceof AppEntity_1.AppEntity) {
            this._appEntity = untrustedValue;
        }
    }
    getAppId() {
        return this._dto.appId;
    }
    setAppId(untrustedValue) {
        let _untrustedValue;
        this.clearError("appId");
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("appId", "App Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.appId) {
            return;
        }
        this._dto.appId = _untrustedValue;
        delete this._appEntity;
        this._setIsDirty(true);
    }
    getUsername() {
        return this._dto.username;
    }
    setUsername(untrustedValue) {
        const maxLength = 45;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("username");
        this._requiredFieldsSetStatus.username = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("username", "Username is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("username", `Username has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.username) {
            return;
        }
        this._dto.username = _untrustedValue;
        this._setIsDirty(true);
    }
    setPasswordAsync(untrustedValue) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const maxLength = 70;
                let _untrustedValue = "";
                if (typeof untrustedValue !== "string") {
                    throw new Error("setPassword(): Invalid type");
                }
                _untrustedValue = untrustedValue.trim();
                this.clearError("password");
                this._requiredFieldsSetStatus.passwordHash = true;
                if (_untrustedValue.length === 0) {
                    this.addError(new ValidationError_1.ValidationError("password", "Password is required."));
                }
                else if (_untrustedValue.length > maxLength) {
                    this.addError(new ValidationError_1.ValidationError("password", `Password has exceeded the maximum length (${maxLength} chr).`));
                }
                else {
                    this._dto.passwordHash = yield this._dependencies.passwordHasher
                        .hashAsync(_untrustedValue);
                    this._setIsDirty(true);
                }
                if (!this.isNew && _untrustedValue === this._dto.passwordHash) {
                    return;
                }
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    getRole() {
        return this._dto.role;
    }
    setRole(untrustedValue) {
        if (typeof untrustedValue !== "string") {
            throw new Error("setRole(): Invalid type");
        }
        const _untrustedValue = untrustedValue.trim();
        this.clearError("role");
        this._requiredFieldsSetStatus.role = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("role", "Role is required."));
        }
        else if (!Object.values(LoginRole_1.LoginRole).includes(_untrustedValue)) {
            this.addError(new ValidationError_1.ValidationError("role", "Role is invalid."));
        }
        if (!this.isNew && _untrustedValue === this._dto.role) {
            return;
        }
        this._dto.role = _untrustedValue;
        this._setIsDirty(true);
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    loadAppAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getAppId()) {
                    return;
                }
                this._emit("before-loadAppAsync");
                this._dto.app = yield this._dependencies.appDatastore
                    .getAsync(this.getAppId(), expand);
                delete this._appEntity;
                this._emit("after-loadAppAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.loginDatastore
                    .getAsync(id, expand);
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadByUsernameAndPasswordAsync(username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof username !== "string") {
                    throw new TypeError("username: Invalid type");
                }
                if (typeof password !== "string") {
                    throw new TypeError("password: Invalid type");
                }
                this._setState("busy");
                this._emit("before-loadByUsernameAndPasswordAsync");
                const logins = yield this._dependencies.loginDatastore.findAsync({
                    selector: {
                        username: { [Operator_1.Operator.EQUALS_TO]: username }
                    },
                    sort: [{ id: "desc" }],
                    objectsPerPage: 1
                });
                if (logins.dtos.length === 0) {
                    throw new AuthenticationRequiredError_1.AuthenticationRequiredError("Wrong username and/or password.");
                }
                else {
                    const passwordHash = logins.dtos[0].passwordHash;
                    const hasMatched = yield this._dependencies.passwordHasher
                        .compareAsync(password, passwordHash);
                    if (!hasMatched) {
                        throw new AuthenticationRequiredError_1.AuthenticationRequiredError("Wrong username and/or password.");
                    }
                    this._dto = logins.dtos[0];
                }
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadByUsernameAndPasswordAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Login is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.loginDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.loginDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Login cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.loginDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.LoginEntity = LoginEntity;
//# sourceMappingURL=LoginEntity.js.map